<template>
  <div class="project_group" ref="group">
    <el-row
      type="flex"
      justify="space-between"
      style="width:100%;min-height: 30px"
      align="middle"
    >
      <template v-if="data.list.length>0 && $store.getters.isMaster">
        <base-title>{{ data.tips || '未分配项目' }}</base-title>
        <!--        <the-collapse-button>展开</the-collapse-button>-->
      </template>
    </el-row>
    <div class="project_group_content clearfix">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import baseTitle from '@/components/Base/baseTitle.vue';
// const defineReactive = Vue.util.defineReactive;
export default {
  name: 'project-group',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    baseTitle,
    theCollapseButton: {
      data() {
        return {
          open: false
        };
      },
      computed: {
        text() {
          return this.open ? '收起' : '展开';
        }
      },
      render: function(h) {
        return h(
          'div',
          {
            class: 'pointer fz18 no-select'
          },
          this.text
        );
      },
      mounted() {
        console.log(this);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.project_group {
  padding: 10px 0 20px 2.5%;
  //background: #fff;
  //margin-bottom: 20px;
  //border-bottom: 1px solid #ebeef5;
  &:not(:first-child) {
    //padding-top: 60px;
    //border-top: 1px dashed #eaeaea;
  }
}
.project_group_content {
  //perspective: 500px;
  /*padding: 0 20px;*/
  /*overflow: hidden;*/
}
</style>
